import { selectIsAuthenticated } from '@/domain/auth/auth.selectors';
import { CalculateFestivalEss } from '@/domain/impact-calculate-festival/entities/calculate-festival-ess.entity';
import { selectImpactCalculateFestivalEssForProject } from '@/domain/impact-calculate-festival/impact-calculate-festival.selectors';
import { selectCurrentProjectFestival } from '@/domain/project-festival/project-festival.selectors';
import { useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

import {
  displayDecimal,
  formatTopicScore,
} from '../../pdf/utils/display-scores.utils';
import ArrowIcon from '../assets/arrow.svg';
import CrossImg from '../assets/cross.svg';
import FairlyScorePillLogo from '../assets/fairly-score-pill-logo.svg';
import { MainScorePill } from '../components/MainScorePill';
export function ScoreCardsFestivalC4() {
  document.documentElement.classList.add('score-card');
  document.body.classList.add('score-card');

  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const festival = useAppSelector(selectCurrentProjectFestival);
  const festivalId = festival?.id ?? 0;

  const impactEss = useAppSelector(
    selectImpactCalculateFestivalEssForProject(festivalId),
  ) satisfies CalculateFestivalEss;

  if (!isAuthenticated) {
    return <h1>{translate('PdfExports.user-not-authentified')}</h1>;
  }

  if (!festival) {
    return <h1>{translate('PdfExports.festival-not-found')}</h1>;
  }

  const impactEssScore100 =
    !impactEss.score || !impactEss.maxScore
      ? 0
      : Math.round((impactEss.score * 100) / impactEss.maxScore);

  return (
    <div id="card4" className="score-card-section">
      <div className="title">
        <img
          src={FairlyScorePillLogo}
          width="80"
          height="80"
          alt="Fairly logo"
        />
        <img src={CrossImg} width="30" height="30" />
        <h1>{festival.name}</h1>
      </div>
      <div className="scores">
        <div className="subtitle">
          <div className="score-row-left">
            <img src={ArrowIcon} width="40" height="40" />
            <span>{translate('Projects.ess')}</span>
          </div>
          <MainScorePill scoreLetter={impactEss.scoreLetter} type="ess" />
        </div>
        <div className="score-row score-highlight">
          <span>{translate('PdfExports.total-score')}</span>
          <span className="highlight">
            {displayDecimal(impactEssScore100)}/{100}
          </span>
        </div>
        <div className="score-row">
          <span>{translate('Ess.Topics.PARITY_EQUALITY')}</span>
          <span>{formatTopicScore(impactEss.topics.PARITY_EQUALITY)}</span>
        </div>
        <div className="score-row">
          <span>{translate('Ess.Topics.ACCESSIBILITY_SOCIAL_DIALOGUE')}</span>
          <span>
            {formatTopicScore(impactEss.topics.ACCESSIBILITY_SOCIAL_DIALOGUE)}
          </span>
        </div>
        <div className="score-row">
          <span>{translate('Ess.Topics.LOCAL_IMPACT_RSE_ENGAGEMENT')}</span>
          <span>
            {formatTopicScore(impactEss.topics.LOCAL_IMPACT_RSE_ENGAGEMENT)}
          </span>
        </div>
      </div>
    </div>
  );
}
